import { useState, useEffect, useRef } from 'react'
import { Section } from '../layout/Section'
import { methodology } from '../../data/methodology'

export function Methodology() {
    const [arrowPosition, setArrowPosition] = useState(150)
    const ticking = useRef(false)

    useEffect(() => {
        const handleScroll = () => {
            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    const section = document.getElementById('metodologia')
                    if (!section) {
                        ticking.current = false
                        return
                    }

                    const rect = section.getBoundingClientRect()
                    const windowHeight = window.innerHeight

                    // Só calcula quando seção está visível
                    if (rect.top < windowHeight && rect.bottom > 0) {
                        // Progress: 0 quando seção aparece no fundo da tela, 1 quando sai pelo topo
                        const rawProgress = (windowHeight - rect.top) / (windowHeight + rect.height)
                        const progress = Math.max(0, Math.min(1, rawProgress))

                        // Detecta se é mobile (< 1024px)
                        const isMobile = window.innerWidth < 1024

                        // CONTROLES DE PARALLAX - ajuste aqui!
                        const startY = isMobile ? 1200 : 550        // Desktop: 550, Mobile: 400
                        const speed = isMobile ? 1500 : 650         // Desktop: 650, Mobile: 500

                        // Posição = início - (progresso * velocidade)
                        const newPosition = startY - (progress * speed)
                        setArrowPosition(newPosition)
                    }

                    ticking.current = false
                })
                ticking.current = true
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <Section id="metodologia" background="gradient">
            {/* Container with relative positioning for absolute arrows */}
            <div className="relative">
                {/* Parallax Arrow Left - GPU accelerated with transform */}
                <div
                    className="absolute left-0 top-0 w-20 lg:w-32 h-auto opacity-20 lg:opacity-30 pointer-events-none z-0 will-change-transform"
                    style={{ transform: `translateY(${arrowPosition}%)` }}
                >
                    <img
                        src="/assets/tres-setas-ascendentes-crescimento-minimalista-alinhado-direita.svg"
                        alt=""
                        className="w-full h-auto"
                    />
                </div>

                {/* Parallax Arrow Right - GPU accelerated with transform */}
                <div
                    className="absolute right-0 top-0 hidden xl:block w-24 h-auto opacity-30 pointer-events-none z-0 will-change-transform"
                    style={{ transform: `translateY(${arrowPosition + 10}%)` }}
                >
                    <img
                        src="/assets/setas-ascendentes-com-ponto-partida-crescimento-alinhado-direita.svg"
                        alt=""
                        className="w-full h-auto"
                    />
                </div>

                {/* Main Content */}
                <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10">
                    {/* Text Content */}
                    <div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-4">
                            Nossa Metodologia
                        </h2>

                        <h3 className="text-xl font-light mb-8 text-white/80">
                            O Caminho para a Evolução Sustentável
                        </h3>

                        <p className="text-white/70 text-lg leading-relaxed mb-8">
                            Acreditamos que toda grande transformação começa com um diagnóstico preciso e um plano estratégico bem definido.
                        </p>
                    </div>

                    {/* Timeline Steps */}
                    <div className="relative">
                        {/* Vertical line */}
                        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-white/20" />

                        <div className="space-y-6">
                            {methodology.map((step) => {
                                const Icon = step.icon
                                return (
                                    <div key={step.id} className="relative flex gap-6 items-center group">
                                        {/* Step circle with icon */}
                                        <div className="relative z-10 w-12 h-12 rounded-full bg-dpxp-accent flex items-center justify-center text-dpxp-dark font-bold text-lg flex-shrink-0 group-hover:scale-110 transition-transform">
                                            {Icon ? <Icon className="w-6 h-6" /> : step.number}
                                        </div>

                                        {/* Content */}
                                        <div className="flex-1 bg-white/5 backdrop-blur-sm rounded-xl p-5 border border-white/10 group-hover:border-dpxp-accent/50 transition-colors">
                                            <h4 className="font-bold text-lg mb-2">{step.title}</h4>
                                            <p className="text-white/70 text-sm leading-relaxed">{step.description}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}
